module.exports = __webpack_public_path__ + "img/23_86.30601ef5.png";